import React, { useEffect } from "react";
import { Button } from "usebeauty";
import { useRoutes } from "@router/Router";
import { useOCRContext } from "@context/OCRContext";
import sdk from "@sdk";
import { ChevronLeft, Close, Logo } from "@Icons";
import "./MainPage.scss";

const MainPage = () => {
  const { step, navigate } = useRoutes();
  const { config: ocrConfig } = useOCRContext();

  const preloadFaceSDK = async () => {
    sdk.face.init();
  };

  const preloadOCRSDK = async () => {
    await sdk.ocr.init(ocrConfig);
  };

  const initialize = async () => {
    preloadOCRSDK();
    preloadFaceSDK();
  };

  useEffect(() => {
    initialize();
  }, []);

  return (
    <div className="alchera-demo-main">
      <div className="background"></div>
      <div className="navigation">
        {step.prev && (
          <Button onClick={() => navigate("prev")}>
            <Close />
          </Button>
        )}
      </div>
      <div className="logo">
        <Logo st={{ color: "inherit", fontSize: "28px" }} />
        <p>통합 데모 솔루션</p>
      </div>
      {step.prev && <Button onClick={() => navigate("prev")}>prev</Button>}
      <Button onClick={() => navigate("next")} ripple={false}>
        <span>다음</span>
        <ChevronLeft st={{ fontSize: "20px" }} />
      </Button>
    </div>
  );
};

export default MainPage;
